import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { t } from 'i18next';
import React from 'react';
import { ControllerProps, FieldErrors } from 'react-hook-form';

import { AutocompleteFormField } from '~components/FormFields/AutocompleteFormField';
import { PhoneCodeFlagInput } from '~components/FormFields/PhoneCodeFlagInput';
import { TextFormField } from '~components/FormFields/TextFormField';
import { RemoveItemButton } from '~pages/Sales/sharedSales/RemoveItemButton';

interface AllContactsContactItemProps {
  arrName: string;
  control: any;
  disabled?: boolean;
  errors: any;
  index: number;
  removeAction: (index: number) => void;
  typeOptions: any;
}
const ContactArrayItem = ({
  arrName,
  control,
  disabled,
  errors,
  index,
  removeAction,
  typeOptions,
}: AllContactsContactItemProps) => {
  const theme = useTheme();
  return (
    <Grid
      container
      size={{ xs: 12 }}
      sx={{
        position: 'relative',
        mt: 2,
        p: 1,
        border: `1px solid ${theme.palette.action.disabledBackground}`,
      }}
    >
      {disabled ? null : (
        <RemoveItemButton
          action={() => {
            removeAction(index);
          }}
          sx={{
            ml: 2,
            position: 'absolute',
            top: '-10px',
            right: '-10px',
            cursor: 'pointer',
          }}
        />
      )}

      <Grid size={{ xs: 12 }} direction={'row'} container spacing={2}>
        <Grid size={{ xs: 4 }}>
          <TextFormField
            control={control}
            disabled={disabled}
            errors={errors}
            isRequired={false}
            label={`${t('form_fields.name')}`}
            name={`${arrName}[${index}].name`}
            sx={{ mr: 2 }}
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <AutocompleteFormField
            clearable={false}
            control={control}
            disabled={disabled}
            errors={errors}
            getLabel={(item) => item.name || ''}
            getValue={(item) => item?.id}
            isRequired={false}
            label={`${t('form_fields.contact_type')}`}
            list={typeOptions}
            name={`${arrName}[${index}].type`}
            sx={{ mr: 2 }}
          />
        </Grid>
        <Grid size={{ xs: 4 }}>
          <PhoneCodeFlagInput
            control={control as unknown as ControllerProps['control']}
            disabled={disabled}
            errors={errors as unknown as FieldErrors}
            isRequired={false}
            label={`${t('form_fields.phone')}`}
            name={`${arrName}[${index}].phone`}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};
export { ContactArrayItem };
